import type {
  ChannelThreadId,
  SupportTicketId,
} from "@redotech/effect-api-shared/ids/definitions";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface RedoChatThreadViewProps {
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
  messageThreadIds?: readonly ChannelThreadId[];
}

export const RedoChatThreadView = memo(function RedoChatThreadView({
  supportTicketId,
  thread,
  messageThreadIds,
}: RedoChatThreadViewProps) {
  return (
    <ChatThreadView
      channel={thread.channel}
      messageThreadIds={messageThreadIds}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
